(function() {
    'use strict';
    angular.module('ekh')
        .config(ekhConfig);

    function ekhConfig($routeProvider) {
        $routeProvider.when('/types/cruises/terms', {
            template: '<div ng-include="cc.template"><h1>Loading...</h1></div>',
            controllerAs: 'cc',
            controller: 'DynamicRouting'
        });
    }
})();
